import React from 'react'
import { PreprocessDatasetService } from "../../../../Services/DjangoServices" 
import FullScreenLoaderAnimation from "../../../CommonComponents/FullScreenLoaderAnimation"

export default function DatasetNotPreprocessed(props) {
        const [apiCallPending, setApiCallPending] = React.useState(false)

        function TriggerProcessing(){
                var body = { "dataset_url": props.dataset_url}
                setApiCallPending(true)
                PreprocessDatasetService(body).then((result) => {
                        result.json().then((data) => {
                                setApiCallPending(false)
                                props.setDatasetProcessed(data["response"]);
                        })
                })
        }
        return (
                <React.Fragment>
                <div className="container-fluid" align="center" >
                                <div style={{fontSize: "22px"}}>
                                        Dataset <span style={{fontWeight: "bold"}}>{props.datast_name}</span> is not preprocessed yet!
                                </div>
                                <div>
                                        <img style={{maxWidth: "450px", width: "80%", maxHeight: "550px"}} src="/images/Dashboard/dataset_not_processed.png" alt="datast not processed"></img>
                                </div>
                                <button className="btn btn-primary" onClick={() => {TriggerProcessing()}}>Preprocess dataset</button>
                </div>
                <FullScreenLoaderAnimation animation_condition={apiCallPending}/>
                </React.Fragment>
        )
}
